


















import { Component, Vue } from 'vue-property-decorator';

import StandardLayout from '@/layouts/standard/StandardLayout.vue';
import IndexPageEmptyState from '@/pages/index/pages/index/components/IndexPageEmptyState.vue';
import IndexPageContent from '@/pages/index/pages/index/IndexPageContent.vue';
import { LocationStore } from '@/store/location';

@Component({
  components: {
    IndexPageContent,
    IndexPageEmptyState,
    StandardLayout,
  },
})
export default class IndexPage extends Vue {

  @LocationStore.Bind.State locationId!: LocationStore.State<'locationId'>;

  goToNew() {
    if (this.$route.name === 'index') {
      this.$router.push('new');
    }
  }

  get keymap() {
    return {
      'alt+n': this.goToNew,
    };
  }

}
